import { Badge, Card, Row, Col, Button, Spinner } from 'react-bootstrap'
import { HiOutlineDotsVertical } from 'react-icons/hi'
import dayjs from "dayjs";
import { rispondiSondaggio, rispondi_bianco_sondaggio } from "../../../utilities/icone";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import ModalPermessi from '../../Utilities/ModalPermessi';
import { statiSondaggio } from '../../Utilities/statiElementEnum';
import { Doughnut } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import CountdownTimer from './CountDownTimer';
import strettaMano from '../../../immagini/strettaMano.jpg';

import SondaggioPartecipanteService from '../../../services/SondaggioPartecipanteService'
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

/*
PROPS:
<InformazioniSondaggio
sondaggio={sondaggio}
activeTab={props.activeTab}
cambiaTab={cambiaTab}
partecipante={props.partecipante}
loadingSon={loadingSon}
totalePartecipantiSondaggio={totalePartecipantiSondaggio}
loadingPartecipazione={loadingPartecipazione}

                                />
*/

export default function InformazioniSondaggio(props) {


    const navigate = useNavigate();
    //const percentuale = (props.totalePartecipantiSondaggio / props.partecipantiTotali) * 100;
    const [haRisposto, setHaRisposto] = useState(false);
    const [mostraModalPermessi, setMostraModalPermessi] = useState(false);
    const [titolo, setTitolo] = useState();
    const [messaggio, setMessaggio] = useState();
    const [mode, setMode] = useState();
    const [disableButton, setDisableButton] = useState()
    const [loadingHaRisposto, setLoadingHaRisposto] = useState(false);

    useEffect(() => {
        console.log(props.partecipante)
        console.log(props.sondaggio)
        const controllaRisposta = async () => {
            console.log("Imposto setLoadingHaRisposto a true");
            setLoadingHaRisposto(true);
            if (props.partecipante?.parId && props.sondaggio?.sonId) {
                SondaggioPartecipanteService.getHaRisposto(props.sondaggio.sonId, props.partecipante.parId)
                    .then((res) => {
                        setHaRisposto(res.data.haRisposto);
                        setDisableButton(res.data.haRisposto)

                    })
                    .catch((err) => {
                        setHaRisposto(false);
                        console.log(err)
                    })
                    .finally(() => { 
                        console.log("impostao setLoadingHaRisposto a false nel finally")
                        setLoadingHaRisposto(false);
                    })
            }
        };
        controllaRisposta();
    }, [props.partecipante, props.sondaggio]);

    /*const chartData = {
        labels: ['Risposte', 'Rimanenti'],
        datasets: [
            {
                data: [props.totalePartecipantiSondaggio, props.partecipantiTotali - props.totalePartecipantiSondaggio],
                backgroundColor: ['#00d0ff', '#e9ecef'],
                borderWidth: 0,
                borderRadius: 10
            }
        ]
    };*/

    /*const chartOptions = {
        responsive: true,

        plugins: {

            legend: { display: false },
            datalabels: {
                display: true,
                color: '#081c2f',
                formatter: (value, ctx) => {
                    const dataset = ctx.chart.data.datasets[0];
                    const total = dataset.data.reduce((acc, val) => acc + val, 0);
                    if (ctx.dataIndex === 0) {
                        return `${((value / total) * 100).toFixed(1)}%`;
                    }
                    return '';
                },
                font: {
                    weight: 'bold',
                    size: 18
                }
            }
        }
    };*/
    


    // eslint-disable-next-line
    const breakPoints = [
        { width: 1, itemsToShow: 1 }
    ];

    const puoRispondere = () => {
        // 1. non loggato => vai a login
        // 2. no permessi => avviso
        // 3. tutto ok
        if (props.partecipante && props.partecipante.parId) {
            if (props.partecipante.ruolo && props.partecipante.ruolo.ruoFlRispondenteSondaggi) {
                //caso 3
                navigate('/rispondi-sondaggio', { state: { sondaggio: props.sondaggio } })
            } else {
                // caso 2
                setTitolo("Attenzione: operazione illecita")
                setMessaggio("Attualmente non possiedi i permessi per rispondere ad un sondaggio L'operazione è bloccata!")
                setMode("danger")
            }
        } else {
            // caso 1
            setTitolo("Attenzione")
            setMessaggio("Per procedere con la compilazione del sondaggio devi prima effettuare il login!")
            setMode("warning")
        }
        setMostraModalPermessi(true)
    }

    return (
        <>
            {props.loadingSon ?
                <div className="bg-light pt-3 align-items-center d-flex justify-content-center" style={{ minHeight: "45vh" }}>
                    <Spinner animation="border" role="status" />
                </div>
                :
                <>
                <div className="bg-light text-center pt-3"
                    style={{
                        backgroundImage: `url(data:image/png;base64,${props.sondaggio && props.sondaggio.sonBanner})`,
                        minHeight: "45vh",
                        backgroundPosition: "center",
                        backgroundSize: "cover"
                    }}
                />
                <div className='mt-4'>
                <h5 className="d-inline me-2"><Badge bg="primary">
                    {
                        props.sondaggio?.sonCategorie && props.sondaggio?.sonCategorie.categorie.map((el, i) => (
                            <span key={i}>
                                <span key={i}>{el}</span>
                                {i !== props.sondaggio?.sonCategorie.categorie.length - 1 &&
                                    <span>, </span>}
                            </span>

                        ))
                    }
                </Badge></h5>                
                <h5 className='d-inline me-2'><Badge bg="primary">{props.sondaggio.sonStato}</Badge></h5>
                {/*TODO SONDAGGI: dare la possibilità all'amministratore di visualizzare o meno le risposte al sondaggio  */}
                {/*<h5 className='d-inline me-2'><Badge bg="primary">{props.totalePartecipantiSondaggio + " risposte"}</Badge></h5>*/}

            </div>

            <Row className='mb-5'>
                <Col className='mt-4 mb-4' xs={12} md={8}>
                    <Card>
                        <Card.Header className="mediumText"><h2 className="title2 text-start mb-3">{props.sondaggio.sonTitolo}</h2></Card.Header>
                        <Card.Body>
                            {props.sondaggio.sonDescrizione && props.sondaggio.sonDescrizione.split("\n").map((val, index) => (
                                <span key={index}>{val} <br /></span>
                            ))}
                        </Card.Body>
                    </Card>
                    {props.sondaggio.sonStato === statiSondaggio.InCorso &&
                        <Card border="primary" className='text-center mt-4 p-3 '>
                            <h4 className='title2 mt-0'>Cosa aspetti?</h4>
                            <Button className="w-50 mx-auto py-2" 
                                disabled={disableButton}
                                onClick={puoRispondere}>
                                Rispondi al sondaggio!
                                <span className="m-2">{rispondi_bianco_sondaggio}</span>
                            </Button>
                        </Card>
                    }
                </Col>
                <Col xs={12} md={4} className=" mb-4">

                    {/*<Card className="h-70 shadow-sm text-center">
                        <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                            <h6 className="fw-bold text-dark mb-3">Partecipazione</h6>
                            <div style={{ width: '160px', height: '160px' }}>
                                <Doughnut data={chartData} options={chartOptions} plugins={[ChartDataLabels]} />
                            </div>
                            <div className="mt-2 small text-muted">
                                {props.totalePartecipantiSondaggio} su {props.partecipantiTotali} hanno risposto
                            </div>
                        </Card.Body>
                    </Card>*/}
                    {!haRisposto || haRisposto == null || haRisposto == undefined ? (
                        <CountdownTimer dataChiusura={props.sondaggio?.sonDataChiusura} stato={props.sondaggio?.sonStato} dataInizio={props.sondaggio?.sonDataInizio} onTimeExpire={props.onTimeExpire}/>
                    ) : (
                        <Card className="mt-3 shadow-sm text-center p-0 overflow-hidden" style={{ position: "relative" }}>
                            <div style={{
                                position: "absolute",
                                top: "10px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                backgroundColor: "rgba(255, 255, 255, 0.8)",
                                padding: "6px 12px",
                                borderRadius: "8px",
                                zIndex: 2
                            }}>
                                <h6 className="text-primary m-0">Grazie per aver partecipato!</h6>
                            </div>
                            <img src={strettaMano} alt="Grazie" style={{ width: "100%", height: "auto", display: "block" }} />
                        </Card>

                    )}


                </Col>
            </Row >
            </>
            }

            
            <ModalPermessi
                mostra={mostraModalPermessi}
                setMostra={setMostraModalPermessi}
                titolo={titolo}
                messaggio={messaggio}
                mode={mode}
            />
        </>
    )
}